import API from '../api';

export default class EmailService {
  constructor() {
    this.API = new API();
  }

  updateEmail = (body) => this.API.put(`/email/`, body);
}
